const _fallbackCopyTextToClipboard = (
  text: string,
  fallbackCopy: (text: string) => void,
): void => {
  const textArea: HTMLTextAreaElement = document.createElement('textarea');

  try {
    textArea.value = text;

    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand('copy');
    if (!successful) {
      fallbackCopy(text);
    }
  } catch (error) {
    fallbackCopy(text);
  } finally {
    document.body.removeChild(textArea);
  }
};

const _clipboardPermissionsCheck = async (): Promise<boolean> => {
  const read = await navigator.permissions.query({
    name: 'clipboard-read' as any,
  });

  const write = await navigator.permissions.query({
    name: 'clipboard-write' as any,
  });

  return write?.state === 'granted' && read?.state !== 'denied';
};

export const copyTextToClipboard = async (
  text: string,
  fallbackCopy: (text: string) => void,
): Promise<void> => {
  if (!text) return;

  try {
    if (navigator.clipboard) {
      const hasPermission = await _clipboardPermissionsCheck();

      if (hasPermission) {
        await navigator.clipboard.writeText(text);
        return;
      }
    }
    _fallbackCopyTextToClipboard(text, fallbackCopy);
  } catch (error) {
    _fallbackCopyTextToClipboard(text, fallbackCopy);
  }
};
